import React, { useState } from "react";
import {
  _iconColor,
  DefaultEditorValue,
  DivContainter,
  DivMain,
  GetBlackCard,
  SpanBigLabel,
} from "./AdminMonthlyWork";
import { BiCableCar, BiLayer } from "react-icons/bi";

import {
  VscMail,
  VscServerProcess,
  VscSettings,
  VscSignOut,
  VscSortPrecedence,
  VscNewFile,
  VscFold,
  VscCalendar,
} from "react-icons/vsc";
import CGDPriceList from "../backoffice/c0001-cgd-price";
import DFRatioList from "../backoffice/c0003-df-ratio-list";
import DFPayment from "./DfRadPay";
import DFRadScheduleEditor from "../backoffice/b0023-df-rad-schedule-editor";
import DfRadScheduler from "../backoffice/b0022-df-rad-scheduler";
import BranchBillingNote from "../backoffice/b0101-branch-billing-note";

export default function AdminRadDF() {
  const [cgdPrice, setCgdPrice] = useState(DefaultEditorValue);
  const [dfRatio, setDfRatio] = useState(DefaultEditorValue);
  const [dfPay, setDfPay] = useState(DefaultEditorValue);
  const [radiSchedule, setRadiSchedule] = useState(DefaultEditorValue);
  const [billingNote, setBillingNote] = useState(DefaultEditorValue);

  const showCgdPrice = (value) => setCgdPrice((pv) => ({ ...pv, show: value }));
  const showDfRatio = (value) => setDfRatio((pv) => ({ ...pv, show: value }));
  const showDfPay = (value) => setDfPay((pv) => ({ ...pv, show: value }));
  const showRadSchedule = (value) =>
    setRadiSchedule((pv) => ({ ...pv, show: value }));
  const showBillingNote = (value) =>
    setBillingNote((pv) => ({ ...pv, show: value }));

  const showButton = false;
  return (
    <DivMain>
      <DivContainter>
        <SpanBigLabel>
          <BiCableCar
            size={30}
            color={_iconColor}
            style={{ marginInline: "10px" }}
          />
          งานสิ้นเดือน Admin
        </SpanBigLabel>
      </DivContainter>

      {showButton ? (
        <DivContainter style={{ backgroundColor: "var(--x-bg-text-input)" }}>
          <GetBlackCard
            buttonTitle="เปิด"
            text="ราคากรมบัญชีกลาง"
            onClick={() => showCgdPrice(true)}
          >
            <VscFold size={120} />
          </GetBlackCard>
          <GetBlackCard
            buttonTitle="เปิด"
            text="กำหนดอัตราการจ่าย"
            onClick={() => showDfRatio(true)}
          >
            <VscSettings size={120} />
          </GetBlackCard>
          <GetBlackCard
            buttonTitle="เปิด"
            text="สร้างเงื่อนไขการจ่าย"
            onClick={() => showCgdPrice(true)}
          >
            <VscSortPrecedence size={120} />
          </GetBlackCard>
          <GetBlackCard
            buttonTitle="เปิด"
            text="กำหนดใช้เงื่อนไขการจ่าย"
            onClick={() => showCgdPrice(true)}
          >
            <VscServerProcess size={120} />
          </GetBlackCard>
        </DivContainter>
      ) : (
        <></>
      )}

      <DivContainter>
        <GetBlackCard
          buttonTitle="เปิด"
          text="ตารางเวรแพทย์"
          onClick={() => showRadSchedule(true)}
        >
          <VscCalendar size={120} />
        </GetBlackCard>

        <GetBlackCard
          buttonTitle="เปิด"
          text="วางบิลสิ้นเดือน"
          onClick={() => showBillingNote(true)}
        >
          <BiLayer size={120} />
        </GetBlackCard>

        <GetBlackCard
          buttonTitle="เปิด"
          text="ออกใบสำคัญจ่ายแพทย์"
          onClick={() => showDfPay(true)}
        >
          <VscNewFile size={120} />
        </GetBlackCard>
      </DivContainter>
      <CGDPriceList {...{ list: [cgdPrice, setCgdPrice] }} />
      <DFRatioList {...{ list: [dfRatio, setDfRatio] }} />
      <DFPayment {...{ list: [dfPay, setDfPay] }} />
      <DfRadScheduler {...{ editor: [radiSchedule, setRadiSchedule] }} />
      <BranchBillingNote {...{ list: [billingNote, setBillingNote] }} />
    </DivMain>
  );
}
